export default {
  confirmLabel: 'Ok',
  backspaceLabel: 'Backspace',
  cancelKeyboardLabel: 'CancelKeyboard'
};
